/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import PropTypes from "prop-types";
import SearchButtonUI from "components/search/SearchButton";
import { getShowSearchInputUI } from "selectors/searchSelectors";
import searchIcon from "dc-icons/global/s_search_18.svg";
import searchIconLight from "assets/s_findindocument_24_light.svg";
import { searchClickHandler, cssSetterHandler, updateSearchStyle } from "components/topbar/actions/find";

const mapStoreToProps = (stores, ownProps) => ({
  isSearchInputVisible: getShowSearchInputUI(stores),
  icon: ownProps.options.color === "light" ? searchIcon : searchIconLight,
  cssSetter: () => {
    cssSetterHandler(stores);
  },
  clickHandler: () => {
    searchClickHandler(stores);
  },
  onMount: () => {
    updateSearchStyle(stores, ownProps);
  },
  onUpdate: () => {
    updateSearchStyle(stores, ownProps);
  }
});

const SearchButtonContainer = inject(mapStoreToProps)(SearchButtonUI);

SearchButtonContainer.propTypes = {
  options: PropTypes.shape({
    color: PropTypes.string.isRequired
  }),
  label: PropTypes.string
};
SearchButtonContainer.defaultProps = {
  options: {
    color: "light"
  },
  label: null
};

export default SearchButtonContainer;
